var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70694 1.70755C8.09694 1.31755 8.09694 0.684557 7.70694 0.29306C7.31694 -0.0984365 6.68395 -0.0969365 6.29245 0.29306L7.70694 1.70755ZM0.998992 7.00101L0.292497 6.29451C-0.0974992 6.68451 -0.0974992 7.31751 0.292497 7.709L0.998992 7.00101ZM6.29245 13.7075C6.68245 14.0975 7.31544 14.0975 7.70694 13.7075C8.09844 13.3175 8.09694 12.6845 7.70694 12.293L6.29245 13.7075ZM6.29245 0.29306L0.292497 6.29451L1.70699 7.7075L7.70694 1.70755L6.29245 0.29306ZM0.292497 7.7075L6.29245 13.7075L7.70694 12.293L1.70699 6.29301L0.292497 7.7075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.f1882c29b7640a6776a36cb3e71ac91d.svg";
export { ForwardRef as ReactComponent };